export default __webpack_public_path__ + "images/iconPlanNight.19be336d3a80da5b418e9c4a724336c6.svg"